export default "__VITE_ASSET__F67Rw6Tu__"